// @flow
import React from "react";
import { errors } from "buba-components";
import NewPasswordView from "buba-components/src/views/NewPassword";
import { isBankAdvisorPasswordRegex } from "buba-components/src/utils/regexes";
import paths from "../../data/paths";

const NewPassword = () => (
  <NewPasswordView
    loginPath={paths.login}
    passwordRegex={isBankAdvisorPasswordRegex}
    passwordError={errors.isPasswordExtended()}
  />
);

export default NewPassword;
